<div fxFlex fxLayout="column" class="padding-20" style="overflow: auto;">
    <ng-container class="list-container" *transloco="let t">
        <div *ngIf="isLoader" class="org-loader">
            <mat-progress-spinner mode="indeterminate" diameter="50" color="primary"></mat-progress-spinner>
            <p>Loading documents...</p>
        </div>
          <div class="breadcrumb-container">
            <nav class="breadcrumb">
                <a routerLink="/user/region">Region</a>
                <span class="separator">/</span>
                <a routerLink="/reference/category">Modules Category</a>
                <span class="separator">/</span>
                <a routerLink="/reference/tiles">Modules</a>
                <span class="separator">/</span>
                <a>Documents</a>
            </nav>
        </div>
        <form [formGroup]="workForceForm" (ngSubmit)="onSave()">
            <div class="details-card">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="details-card-header site-detail-header">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="padding-top: 16px;">
                        <h3>{{ headingLabel }}</h3>
                    </div>

                    <div fxFlex="initial" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
                        <button mat-raised-button type="submit" color="primary" class="sml-button" [disabled]="!canSave"
                            [ngStyle]="{ 'background-color': !canSave ? 'white' : '#ea7600', 'color': !canSave ? 'black' : 'white',
                               'border-radius': '10px','border': !canSave ? '2px solid black' : 'none'}">
                            Save
                        </button>
                    </div>
                </div>

                <div class="document-grid">
                    <mat-table [dataSource]="documentsArray.controls" formArrayName="uploadDocuments"
                        class="propcentra-grid">

                        <!-- Document Name Column -->
                        <ng-container matColumnDef="name">
                            <mat-header-cell *matHeaderCellDef> Document Name </mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                <span style="cursor: default;">
                                    {{ row.get('name').value }}
                                </span>
                            </mat-cell>
                        </ng-container>

                        <!-- Upload Documents Column -->
                        <ng-container matColumnDef="uploadDocuments">
                            <mat-header-cell *matHeaderCellDef> Upload Documents </mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                <div
                                    style="display: flex; flex-direction: column; gap: 8px; min-height: 50px; padding: 4px 0;">

                                    <!-- Upload control -->
                                    <div>
                                        <input type="file" multiple accept=".jpeg,.jpg,.pdf,.doc,.docx,.xls,.xlsx"
                                            (change)="onUpload($event, i)" [disabled]="!tiles.canEdit" />
                                    </div>

                                    <!-- Uploaded files list -->
                                    <div *ngIf="row.get('uploadedFiles').value?.length"
                                        style="overflow-y: auto; max-height: 100px;">
                                        <div *ngFor="let file of row.get('uploadedFiles').value; let j = index"
                                            style="display: flex; align-items: center; justify-content: space-between; padding: 4px 0; border-bottom: 1px solid #e0e0e0;">
                                            <span>
                                                📎 {{ file.name }} ({{ file.size | number }} bytes)
                                            </span>
                                            <button mat-icon-button color="warn" (click)="removeUploadedFile(i, j)"
                                                *ngIf="!file.saved">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="uploadedFiles">
                            <mat-header-cell *matHeaderCellDef> Uploaded files </mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                <span style="text-align: right; cursor: default;">
                                    {{ getFileCount(i) }}
                                </span>
                            </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                <span [ngStyle]="{ color: (row.get('status')?.value === 'Approve' || row.get('status')?.value === 'Approved') ? 'green' 
                                        : (row.get('status')?.value === 'Reject' || row.get('status')?.value === 'Rejected') ? 'red' 
                                        : (row.get('status')?.value === 'Reject' || row.get('status')?.value === 'Rejected') ? 'red' 
                                        : row.get('status')?.value === 'Under review' ? 'orange' 
                                        : 'gray',  'font-weight': 'bold', 'cursor': 'default'  }">
                                    {{ row.get('status')?.value }}
                                </span>

                            </mat-cell>
                        </ng-container>


                        <!-- Actions Column -->
                        <ng-container matColumnDef="actions">
                            <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                            <mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
                                <button mat-button type="button" color="primary" (click)="onView(row.get('id').value)"
                                    [disabled]="!tiles.canView">
                                    {{ t('DocumentArchive.view') }}
                                </button>
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
                    </mat-table>
                </div>


            </div>
        </form>

    </ng-container>
</div>